import { FunctionComponent, ReactNode, useEffect, useState } from "react";

import { applicationConfig } from "../../../../environmentConfiguration";
import { useTermsOfUseService } from "../../../services/ServiceHooks/termsOfUseHook";
import { TermsOfUseVerification } from "../../Core/TermsOfUseDialog/TermsOfUseVerification";

interface ITermsOfUseGuardProps {
  children: ReactNode;
}

export const TermsOfUseGuard: FunctionComponent<ITermsOfUseGuardProps> = props => {
  const termsOfUseService = useTermsOfUseService();
  const [isLoading, setIsLoading] = useState(false);
  const [termsOfConditionsBase64Document, setTermsOfConditionsBase64Document] = useState<string | null>(null);

  const fetchTermsOfUse = async () => {
    setIsLoading(true);

    const termsOfUsePdfBase64 = await termsOfUseService.getCurrentTermsOfUse();
    if (termsOfUsePdfBase64) {
      setTermsOfConditionsBase64Document(termsOfUsePdfBase64);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (applicationConfig.featureFlags.enableTermsOfUse) {
      fetchTermsOfUse();
    }
  }, []);

  if (applicationConfig.featureFlags.enableTermsOfUse) {
    if (isLoading) {
      return null;
    }

    if (termsOfConditionsBase64Document) {
      return (
        <TermsOfUseVerification
          isLoading={isLoading}
          termsOfConditionsBase64Document={termsOfConditionsBase64Document}
          onAccepted={() => {
            // Clear terms so guard will render children on next render
            setTermsOfConditionsBase64Document(null);
          }}
        />
      );
    }
  }

  return props.children;
};
